import TableRow from '@mui/material/TableRow'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import AdvancedTable from 'components/AdvancedTable'
import { renderCells } from 'utils/renderCells'
import { LabelBox } from 'components/label-box'
import { useAppContext } from 'context/AppContext/AppContext'

type FailCheckSummary = {
  code: string
  marketId: number
  count: number
}

const BarcodeFailChecksSummary = (): JSX.Element => {
  const { t } = useTranslation()
  const { markets } = useAppContext()

  const marketOptions = useMemo(
    () =>
      markets !== undefined && 'data' in markets
        ? markets.data
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(el => ({
              id: el.id.toString(),
              value: el.name + (el.description ? ` (${el.description})` : ''),
            }))
        : [],
    [markets]
  )

  return (
    <AdvancedTable<FailCheckSummary>
      name="barcode-fail-checks-summary"
      endpoint="barcodes/fail-checks/summary"
      orderField="count"
      orderDir="DESC"
      headings={[
        { type: 'text', name: t('common.code'), field: 'code', width: 220 },
        { type: 'options', name: t('common.marketName'), field: 'marketId', width: 200 },
        { type: 'empty', name: t('barcode.count', 'Count'), field: 'count', sort: true, width: 100 },
      ]}
      options={{
        marketId: marketOptions,
      }}
      renderRow={(row, idx) => (
        <TableRow key={idx}>
          {renderCells([
            { label: t('common.code'), value: <LabelBox first={row.code} /> },
            {
              label: t('common.marketName'),
              value: (
                <LabelBox
                  first={marketOptions.find(m => m.id === row.marketId.toString())?.value ?? `#${row.marketId}`}
                />
              ),
            },
            { label: t('barcode.count', 'Count'), value: <LabelBox first={String(row.count)} /> },
          ])}
        </TableRow>
      )}
    />
  )
}

export default BarcodeFailChecksSummary
